// import React from 'react';
// import ReactApexChart from 'react-apexcharts';
// import './dashboard.css';

// const DashboardComponent = () => {



//   return (
//     <div className="content-wrapper vendor">
//       {/* Content Header (Page header) */}
//       <div className="content-header">
//         <div className="d-flex align-items-center">
//           <div className="mr-auto w-p50">
//             <h3 className="page-title">Analytics</h3>
//             <div className="d-inline-block align-items-center">
//               <nav>
//                 <ol className="breadcrumb">
//                   <li className="breadcrumb-item"><a href="#"><i className="mdi mdi-home-outline"></i></a></li>
//                   <li className="breadcrumb-item active" aria-current="page">Control</li>
//                 </ol>
//               </nav>
//             </div>
//           </div>
//           <div className="right-title text-right w-170">
//             <span className="subheader_daterange font-weight-600" id="dashboard_daterangepicker">
//               <span className="subheader_daterange-label">
//                 <span className="subheader_daterange-title"></span>
//                 <span className="subheader_daterange-date text-primary"></span>
//               </span>
//               <a href="#" className="btn btn-sm btn-primary">
//                 <i className="fa fa-angle-down"></i>
//               </a>
//             </span>
//           </div>
//         </div>
//       </div>

//       {/* Main content */}
//       <section className="content">
//         <div className="row">
//           <div className="col-md-12 col-lg-4">
//             <div className="box box-body bg-success">
//               <div className="flexbox">
//                 <div id="linechart"></div>
//                 <div className="text-right">
//                   <span>New Users</span><br />
//                   <span>
//                     <i className="ion-ios-arrow-up text-white"></i>
//                     <span className="font-size-18 ml-1">589</span>
//                   </span>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="col-md-12 col-lg-4">
//             <div className="box box-body bg-warning">
//               <div className="flexbox">
//                 <div id="barchart"></div>
//                 <div className="text-right">
//                   <span>Yearly PO</span><br />
//                   <span>
//                     <i className="ion-ios-arrow-up text-white"></i>
//                     <span className="font-size-18 ml-1">300</span>
//                   </span>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="col-md-12 col-lg-4">
//             <div className="box box-body bg-primary">
//               <div className="flexbox">
//                 <div id="discretechart"></div>
//                 <div className="text-right">
//                   <span>Yearly Quotations</span><br />
//                   <span>
//                     <i className="ion-ios-arrow-up text-white"></i>
//                     <span className="font-size-18 ml-1">500</span>
//                   </span>
//                 </div>
//               </div>
//             </div>
//           </div>


//         </div>
//       </section>
//       {/* /.content */}
//     </div>
//   );
// }

// export default DashboardComponent;





import React from 'react';
import ReactApexChart from 'react-apexcharts';


const ContentHeader = () => {
  return (
    <section className="content">
      <div className="container-fluid row d-flex">
        <div className="block-header col-md-11">
          <div className="row d-flex col-md-12">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <ul className="breadcrumb">
                <li className="breadcrumb-item bcrumb-1">

                   Analytics

                </li>
                <li className="breadcrumb-item active"> <i className="fa fa-home"></i>Control</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="right-title text-right w-170 col-md-1">
          <span className="subheader_daterange font-weight-600" id="dashboard_daterangepicker">
            <span className="subheader_daterange-label">
              <span className="subheader_daterange-title"></span>
              <span className="subheader_daterange-date text-primary"></span>
            </span>
            <a className="btn btn-lg btn-primary" href="#"><i className="fa fa-angle-down"></i></a>
          </span>
        </div>
      </div>
    </section>
  );
};


function DashboardCard(props) {
  const cardStyle = {
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)' // Add your desired box shadow style here
  };

  return (
    <div className={`col-md-6 ${props.additionalClass}`} style={{padding:'0.5em'}}>
      <div className="cord" style={cardStyle}>
        <div className="cord-body">
          <div className="media align-items-center p-0">
            <h3 className="mx-0 mb-2 font-weight-500">{props.title}</h3>
          </div>
          <div className="flexbox align-items-center mt-2">
            <div>
              <h4 className="no-margin"><span className={props.valueClass}>{props.value}</span></h4>
            </div>
          </div>
        </div>
        <div className="cord-footer p-0 no-border">
          <div className="chart"><canvas id={props.chartId} className="h-80"></canvas></div>
        </div>
      </div>
    </div>
  );
}

export default function App() {

  // Example data for the charts
  const commonOptions = {
    chart: {

      toolbar: {
        show: false,
      },
    },
    xaxis: {
      labels: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        show: false,
      },
    },
  };

  const lineChartOptions = {
    ...commonOptions,
    stroke: {
      curve: 'smooth',
    },
  };

  const lineChartData = [
    {
      name: 'Line Chart Example',
      data: [10, 15, 20, 18, 25],
    },
  ];

  const barChartOptions = {
    ...commonOptions,
    plotOptions: {
      bar: {
        horizontal: false,
      },
    },
  };

  const barChartData = [
    {
      name: 'Bar Chart Example',
      data: [8, 12, 15, 10, 7],
    },
  ];

  const candlestickChartOptions = {
    ...commonOptions,
    xaxis: {
      ...commonOptions.xaxis,
      type: 'datetime',
    },
    yaxis: {
      tooltip: {
        enabled: false,
      },
    },
    stroke: {
      show: false,
    },
  };

  const candlestickChartData = [
    {
      x: new Date('2023-01-01').getTime(),
      y: [10, 15, 5, 12],
    },
    {
      x: new Date('2023-02-01').getTime(),
      y: [12, 18, 8, 16],
    },
    {
      x: new Date('2023-03-01').getTime(),
      y: [16, 20, 10, 18],
    },
    {
      x: new Date('2023-04-01').getTime(),
      y: [18, 22, 12, 20],
    },
    {
      x: new Date('2023-05-01').getTime(),
      y: [20, 25, 15, 22],
    },
  ];



  const barChartOptions9 = {
    chart: {
      toolbar: {
        show: false
      }
    },
    xaxis: {
      categories: ['Admin', 'SBI', 'ILS', 'IT'],
      title: {
        text: 'Department',
        style: {
          fontSize: '12px'
        }
      }
    },
    yaxis: {
      title: {
        text: 'Count',
        style: {
          fontSize: '12px'
        }
      }
    },
    title: {
      text: 'Pending PRF',
      align: 'left',
      style: {
        fontSize: '14px',
        color: '#48CAE4'
      }
    },
  };

  const barChartData9 = [{
    data: [3, 5, 2, 4],
    name: 'Chart Label'
  }];

  const lineChartColors = [
    {
      backgroundColor: 'rgba(100, 141, 164)',
      borderColor: 'rgba(77,83,96,1)',
    },
  ];

  const barChartData1 = [{ data: [6, 7, 5, 4], label: 'Chart Label' }];
  const barChartLabels1 = ['Admin', 'SBI', 'ILS', 'IT'];
  const barChartOptions1 = {
    scales: {
      yAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: 'Count',
          },
        },
      ],
      xAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: 'Department',
          },
        },
      ],
    },
    title: {
      display: true,
      text: 'Pending PRF',
      fontSize: 14,
      fontColor: '#48CAE4',
    },
  };

  const barChartOptions2 = {
    scales: {
      yAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: 'Count',
          },
        },
      ],
      xAxes: [
        {
          scaleLabel: {
            display: true,
            labelString: 'Year',
          },
        },
      ],
    },
    title: {
      display: true,
      text: 'Pending PRF',
      fontSize: 14,
      fontColor: '#48CAE4',
    },
  };

  const barChartLabels2 = ['2018', '2019', '2020', '2021'];
  const barChartType2 = 'line';
  const barChartLegend2 = true;
  const barChartData2 = [{ data: [6, 7, 5, 4], label: 'Chart Label' }];
  const lineChartColors2 = [
    {
      backgroundColor: 'rgba(77,83,96,0.2)',
      borderColor: 'rgba(77,83,96,1)',
    },
  ];

  const cardStyle1 = {
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)' // Add your desired box shadow style here
  };

  return (
    <>
      <div>
        <ContentHeader />

      </div>
      <div className='m-2'>

        <div className="container-fluid row">
          <div className=" d-flex bg-success me-2" style={{ width: '32%' }}>
            <div>
              <ReactApexChart
                options={lineChartOptions}
                series={lineChartData}
                type="line"
                height={150}
              />
            </div>
            <div className="text-right">
              <span>New Users</span>
              <br />
              <span>
                <i className="ion-ios-arrow-up text-white"></i>
                <span className="font-size-18 ml-1">589</span>
              </span>
            </div>
          </div>
          <div className=" d-flex bg-warning me-2" style={{ width: '32%' }}>
            <div>
              <ReactApexChart
                options={barChartOptions}
                series={barChartData}
                type="bar"
                height={150}
              />
            </div>
            <div className="text-right">
              <span>New Users</span>
              <br />
              <span>
                <i className="ion-ios-arrow-up text-white"></i>
                <span className="font-size-18 ml-1">589</span>
              </span>
            </div>
          </div>
          <div className=" bg-primary d-flex" style={{ width: '32%' }}>
            <div>
              <ReactApexChart
                options={candlestickChartOptions}
                series={[{ data: candlestickChartData }]}
                type="candlestick"
                height={150}
              />
            </div>
            <div className="text-right">
              <span>New Users</span>
              <br />
              <span>
                <i className="ion-ios-arrow-up text-white"></i>
                <span className="font-size-18 ml-1">589</span>
              </span>
            </div>
          </div>
        </div>

      </div>

      <div className="row d-flex m-2">
        <div className="col-md-7 row">
          <DashboardCard additionalClass="text-left" title="No of PRF Approved" value="100" valueClass="text-primary" chartId="chartjs1" />
          <DashboardCard additionalClass="text-left" title="Total Value of PO" value="17,800 Lakh" valueClass="text-success" chartId="chartjs2" />
          <DashboardCard additionalClass="text-left" title="Issued PO" value="389" valueClass="text-warning" chartId="chartjs3" />
          <DashboardCard additionalClass="text-left" title="Registered Vendors" value="2995" valueClass="text-info" chartId="chartjs4" />
        </div>
        <div className="col-md-5">
          <div className="cord" style={cardStyle1}>
            <div className="card-header d-flex justify-content-between">
              <h4 className="card-title">PRF AT P2P TEAM</h4>
              <div className="cord-tools">
                <a href="#" className="btn btn-tool"><i className="fas fa-times"></i></a>
                <a href="#" className="btn btn-tool"><i className="fas fa-arrows-alt"></i></a>
                <a href="#" className="btn btn-tool"><i className="fas fa-expand-arrows-alt"></i></a>
              </div>
            </div>
            <div className="card-body">
              <ReactApexChart
                type="bar"
                series={barChartData9}
                options={barChartOptions9}
                height={340}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="row d-flex m-2">
        <div className="col-md-7">
          {/* Yearly Purchase Chart */}
          <div className="cord" style={cardStyle1}>
            <div className="card-header d-flex justify-content-between">
              <h4 className="card-title">Yearly Purchase</h4>
              <div className="card-tools">
                <a href="#" className="btn btn-tool"><i className="fas fa-times"></i></a>
                <a href="#" className="btn btn-tool"><i className="fas fa-arrows-alt"></i></a>
                <a href="#" className="btn btn-tool"><i className="fas fa-expand-arrows-alt"></i></a>
              </div>
            </div>
            <div className="card-body">
              <ReactApexChart
                type={barChartType2}
                series={barChartData2}
                options={barChartOptions2}
                height={340}
              />
            </div>
          </div>
        </div>
        <div className="col-md-5">
          {/* PRF At Finance TEAM Chart */}
          <div className="cord mt-4" style={cardStyle1}>
            <div className="card-header d-flex justify-content-between">
              <h4 className="card-title">PRF At Finance TEAM</h4>
              <div className="card-tools">
                <a href="#" className="btn btn-tool"><i className="fas fa-times"></i></a>
                <a href="#" className="btn btn-tool"><i className="fas fa-arrows-alt"></i></a>
                <a href="#" className="btn btn-tool"><i className="fas fa-expand-arrows-alt"></i></a>
              </div>
            </div>
            <div className="card-body">
              <ReactApexChart
                type='bar'
                series={barChartData1}
                options={barChartOptions1}
                height={340}
              />
            </div>
          </div>
        </div>
      </div>

    </>

  );
}